import React from 'react';

import { EmptyState } from '@ergeon/core-components';
import { CurrencyDollarIcon } from '@ergeon/icons/hero/outline';

export const NoOrdersEmptyState = () => (
  <div className="flex flex-col justify-center items-center p-6 pb-12 h-full">
    <EmptyState
      description="Try adjusting your filters."
      icon={<CurrencyDollarIcon />}
      title="No orders found" />
  </div>
);
